import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  CONFERENCE,
  CONFERENCE_ALL,
  CONFERENCE_ALL_FILTER,
  CONFERENCE_ARTICLE,
  CONFERENCE_ARTICLE_ALL,
  CONFERENCE_ARTICLE_LIST,
  CONFERENCE_ARTICLE_PROOF,
  CONFERENCE_ARTICLE_STEP,
  CONFERENCE_CATEGORY_ALL,
  CONFERENCE_CREATE,
  CONFERENCE_MAGAZINE_ARTICLE,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const conferenceSelectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const conferenceSelector = createSelector(conferenceSelectors, prop(CONFERENCE))

export const conferenceCreateSelector = createSelector(conferenceSelectors, prop(CONFERENCE_CREATE))

export const conferenceAllSelector = createSelector(conferenceSelectors, prop(CONFERENCE_ALL))

export const conferenceAllFilterSelector = createSelector(conferenceSelectors, prop(CONFERENCE_ALL_FILTER))

export const conferenceArticleSelector = createSelector(conferenceSelectors, prop(CONFERENCE_ARTICLE))

export const conferenceArticleListSelector = createSelector(conferenceSelectors, prop(CONFERENCE_ARTICLE_LIST))

export const conferenceArticleAllSelector = createSelector(conferenceSelectors, prop(CONFERENCE_ARTICLE_ALL))

export const conferenceMagazineArticleSelector = createSelector(conferenceSelectors, prop(CONFERENCE_MAGAZINE_ARTICLE))

export const conferenceArticleStepSelector = createSelector(conferenceSelectors, prop(CONFERENCE_ARTICLE_STEP))

export const conferenceArticleProofSelector = createSelector(conferenceSelectors, prop(CONFERENCE_ARTICLE_PROOF))

export const conferenceCategoryAllSelector = createSelector(conferenceSelectors, prop(CONFERENCE_CATEGORY_ALL))
